<template>
  <portal to="modals" v-if="$store.state.modals.gradingModel">
    <modal-component
      :show="true"
      @close="closeModal"
      container-classes="max-w-content-xl my-12.5 md:my-0"
      wrapper-classes="flex"
    >
      <slot></slot>
    </modal-component>
  </portal>
</template>

<script>
import ModalComponent from './ModalComponent.vue';

export default {
  components: { ModalComponent },

  methods: {
    closeModal() {
      this.$store.commit('modals/SET_GRADING_MODAL', false);
    },
  },
};
</script>
